import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FikoYTKokBilesenComponent } from '@/src/service/kok-bilesen/kok-bilesen.component';
import { paramDeger } from '@/src/app/shared/utils/param-deger.utils';

@Component({
  selector: 'uretim-sayac-kart-sade',
  standalone: true,
  imports: [CommonModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `
    <div class="sk" style="--sk-accent:#722ed1">
      <div class="sk-icerik">
        <div class="sk-baslik">{{ deger('tezgah') || 'Isimsiz Tezgah' }}</div>
        @if (deger('urun')) { <div class="sk-alt">{{ deger('urun') }}</div> }
        <div class="sk-stat">
          <span>Hedef: <b>{{ deger('hedef') || 0 }}</b></span>
          <span>Gercek: <b>{{ deger('gerceklesen') || 0 }}</b></span>
          <span>Fire: <b>{{ deger('fire') || 0 }}</b></span>
        </div>
      </div>
      <div class="sk-sag">
        <span style="font-size:14px;font-weight:700;color:var(--sk-accent)">%{{ verimlilik() }}</span>
      </div>
    </div>
  `,
})
export class UretimSayacKartSadeComponent extends FikoYTKokBilesenComponent {
  parametreler = input<any>();
  constructor() { super(); }
  p = computed(() => this.parametreler()?.ek || {});
  deger(alan: string): any { return paramDeger(this.p(), alan); }
  verimlilik = computed(() => {
    const hedef = +(this.deger('hedef') || 0);
    const gercek = +(this.deger('gerceklesen') || 0);
    if (!hedef) return 0;
    return Math.round((gercek / hedef) * 100);
  });
}
